<mat-toolbar class="footer">
  <img
    class="footer__building-logo"
    [src]="buildingLogo"
  />
  <span class="footer__copyright">
    &copy; {{ year }} <a href="https://389nm.com" target="_blank" rel="noopener noreferrer">389nm LLC</a>
  </span>
</mat-toolbar>
